import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const Channel = Loadable(lazy(() => import('views/Channel')));
const Log = Loadable(lazy(() => import('views/Log')));
const Histroy = Loadable(lazy(() => import('views/Histroy')));
const ApiDoc = Loadable(lazy(() => import('views/API')));
const Redemption = Loadable(lazy(() => import('views/Redemption')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const Model = Loadable(lazy(() => import('views/Model')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const Pay = Loadable(lazy(() => import('views/Pay')));
const User = Loadable(lazy(() => import('views/User')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));
const System = Loadable(lazy(() => import('views/system')));



// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <Dashboard />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'channel',
      element: <Channel />
    },
    {
      path: 'log',
      element: <Log />
    },{
      path: 'history',
      element: <Histroy />
    },
    {
      path: 'redemption',
      element: <Redemption />
    },
    {
      path: 'setting',
      element: <Setting />
    },
    {
      path: 'system',
      element: <System />
    },
    {
      path: 'token',
      element: <Token />
    },
    {
      path: 'model',
      element: <Model />
    },
    {
      path: 'topup',
      element: <Topup />
    },
    {
      path: 'pay',
      element: <Pay />
    },
    {
      path: 'user',
      element: <User />
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: '404',
      element: <NotFoundView />
    }
    // 移除原来的api子路由
  ]
};


// 导出合并后的路由配置
export default MainRoutes;
